import React, { ReactNode } from 'react';

import { Box, Center, Stack } from '@chakra-ui/react';
import { useSelector } from 'react-redux';
import { customTheme } from 'theme';

import { CustomSpinner } from 'components/DataDisplay/Spinner/CustomSpinner';
import { selectBlueprints } from 'containers/PolicyHub/Blueprints/selectors';

interface Props {
  icon: ReactNode;
  label: string;
  onClick?();
}

export const BlueprintDetailCard: React.FC<Props> = props => {
  const { icon, label, onClick } = props;

  const { blueprint, blueprintSummary, attachedWorkflows } = useSelector(
    selectBlueprints,
  );

  const getValue = () => {
    switch (label) {
      case 'Policies':
        return blueprintSummary.data?.total_policies || 0;
      case 'Exceptions':
        return (
          (blueprintSummary.data?.check_stats?.resource_exceptions || 0) +
          (blueprintSummary.data?.check_stats?.rule_exceptions || 0)
        );
      case 'Workflows':
        return attachedWorkflows.data?.length || 0;
      case 'Clouds':
        return blueprint.data?.clouds?.length;
      case 'Accounts':
        return blueprint.data?.accounts?.length;
      case 'Environments':
        return blueprint.data.configs?.length ?? 0;
      default:
        return 0;
    }
  };

  const getIsLoading = () => {
    switch (label) {
      case 'Workflows':
        return attachedWorkflows.isLoading;
      case 'Accounts':
      case 'Clouds':
      case 'Environments':
        return blueprint.isLoading;
      default:
        return blueprintSummary.isLoading;
    }
  };

  return (
    <Box
      w="full"
      h="full"
      pt={4}
      onClick={onClick}
      cursor={onClick ? 'pointer' : 'default'}
    >
      <Stack spacing={6}>
        <Center>
          <Center boxSize={8} color="primary">
            {icon}
          </Center>
        </Center>
        <Box>
          <Center fontSize="2xl" lineHeight={1}>
            {getIsLoading() ? <CustomSpinner /> : getValue()}
          </Center>
          <Center color={customTheme.colors.gray['250']}>{label}</Center>
        </Box>
      </Stack>
    </Box>
  );
};
